import React from "react";
import {
  AppBar,
  Toolbar,
  Container,
  IconButton,
  Grid,
  Typography,
  Box,
} from "@mui/material";
import Logo from "../../Assets/Logo.svg";
import AdminLoginForm from "../../compenents/Auth/AdminLoginForm";

export interface AdminLoginFormValues {
  dmsDealerId?: string;
  username: string;
  password: string;
  userType?: number;
}

export const AdminLogin: React.FunctionComponent = () => {
  return (
    <>
      <AppBar position="static" variant="outlined">
        <Toolbar
          variant="dense"
          disableGutters
          style={{ minHeight: 64 }}
        ></Toolbar>
      </AppBar>
      <Container
        component="div"
        maxWidth="xs"
        style={{ marginTop: "5%", height: "100%" }}
      >
        <Grid
          container
          style={{
            height: "100%",
            textAlign: "center",
          }}
        >
          <Grid item>
            <Typography noWrap component="div" sx={{ flexGrow: 1, mt: 2 }}>
              <img style={{ maxWidth: "290px" }} src={Logo}></img>
            </Typography>
            <Box component="div" mt={2}>
              <Typography component="h1" variant="h5">
                Admin Log In
              </Typography>
            </Box>
            <AdminLoginForm></AdminLoginForm>
          </Grid>
        </Grid>
      </Container>
    </>
  );
};
